import React from "react";
import { IField, IPage } from "../../interfaces";
import { context } from "../..";

export default function PreviousAnswers ({
    writePdf = (lineObject) => {}
}) {

    const submittedPages = context.getSubmittedPages()

    const goToPage = (pageIndex) => {
        if (context.showPreviousAnswers) {
            context.togglePreviousAnswers()
        }
        context.setPageIndex(pageIndex)
        window.scrollTo(0, 0);
    }

    return (
        <div className="previous-answers">
            {submittedPages?.map((page: IPage, p) => {
                
                var pageOrderInd = (p + 1) * 10000
                writePdf({type: "h2", content: context.formatLabel(page.title), orderInd: pageOrderInd})
                
                return (
                    <div key={p}>
                        <h4 className="link" onClick={() => goToPage(p)} style={{marginBottom: "5px", textDecoration: "underline"}}>
                            {context.formatLabel(page.title)}
                        </h4>

                        <div style={{padding: "0 10px"}}>
                            {page.fields?.map((field: IField, i) => (
                                <QuestionnaireField key={i} orderInd={pageOrderInd + ((i + 1) * 10)} writePdf={writePdf} field={field} answers={context.answers} />
                            ))}

                            {page.table ? context.answers[page.table?.list_name]?.map((tableEntryAnswers, iEntry) => {
                                if (iEntry > 0 && iEntry < context.answers[page.table?.list_name].length) {
                                    writePdf({type: "label", label: "---------------------------------------------------------------------------", orderInd: pageOrderInd + ((iEntry + 1) * 100)})
                                }
                                return (
                                    <div key={iEntry}>
                                        {iEntry > 0 ? <div style={{height: "0.5px", width: "auto", margin: "5px 10px", backgroundColor: "grey"}}></div> : null}

                                        {page.table.fields.map((field, i) => (
                                            <QuestionnaireField key={i} orderInd={pageOrderInd + ((iEntry + 1) * 100) + ((i + 1) * 10)} writePdf={writePdf} field={field} answers={{...context.answers, ...tableEntryAnswers}} />
                                        ))}
                                    </div>
                                )
                            }) : null}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

function QuestionnaireField ({
    orderInd,
    field, 
    answers,
    writePdf = (lineObject) => {}
}) {

    if (!field.name || context.isHidden(field, answers)) {
        return <React.Fragment key={JSON.stringify(field)}></React.Fragment>
    }

    var displayValue = answers[field.name]

    if (field?.setListKey) {
        var displayDict = context.getListSet(field?.setListKey)
        displayValue = displayDict[displayValue] ? displayDict[displayValue] : displayValue
    } else if (field.options) {
        displayValue = displayValue in field.options ? field.options[displayValue] : displayValue
    } else if (["true", "false"].includes(displayValue)) {
        displayValue = displayValue === "true" ? "Yes" : "No"
    } else if (field.type === "file") {
        var upload = context.uploads.find(u => u.uid === displayValue)
        if (upload) {
            displayValue = upload.displayName
        }
    }

    var label = context.formatLabel(field.label)
    displayValue = context.formatLabel(displayValue)

    writePdf({type: "paragraph", content: label, orderInd: orderInd})
    writePdf({type: "field-value", content: displayValue, orderInd: orderInd + 1})

    return (
        <div className="previous-answers-field">
            <small>{label}</small>
            
            <span></span>
            
            {displayValue 
                ? <small data-value={displayValue}>{displayValue}</small>
                : <small data-value={displayValue} style={{color: "grey"}}><i>Empty</i></small>}
        </div>
    )
}